import type { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles/components';

export const MuiTypography: Components<Theme>['MuiTypography'] = {
  defaultProps: {
    color: 'text.primary',
  },
  styleOverrides: {
    root: {
      fontFamily: 'Gellix',
    },
  },
};
